import React, { useEffect } from 'react';
import type { MessageDescriptor } from 'react-intl-next';
import { FormattedMessage } from 'react-intl-next';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

/**
 * TODO CNS-7388: These are placeholders while illustrations are being finalized
 * Remove this comment once these images have been replaced with the final illustrations
 */
import WhiteboardsLight from './images/Whiteboards-Light.svg';
import WhiteboardsDark from './images/Whiteboards-Dark.svg';
import type { OnboardingSlide } from './OnboardingModal';

export const getWhiteboardsSlide = (
	title: MessageDescriptor,
	body: MessageDescriptor,
	userPrivilege: 'siteAdmin' | 'user',
) =>
	({
		title: <FormattedMessage {...title} />,
		body: <WhiteboardsSlideBody body={body} userPrivilege={userPrivilege} />,
		// Place holder while
		imageUrlLight: WhiteboardsLight,
		imageUrlDark: WhiteboardsDark,
	}) as OnboardingSlide;

type WhiteboardSlideBodyProp = {
	body: MessageDescriptor;
	userPrivilege: 'siteAdmin' | 'user';
};

export const LEARN_MORE_LINK_TEST_ID = 'whiteboards-premium-onboarding-learn-more-link';

const WhiteboardsSlideBody = ({ body, userPrivilege }: WhiteboardSlideBodyProp) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	useEffect(() => {
		createAnalyticsEvent({
			type: 'sendScreenEvent',
			data: {
				name: 'whiteboardsPremiumOnboarding',
				attributes: {
					userPrivilege: `${userPrivilege}`,
				},
			},
		}).fire();
	}, [createAnalyticsEvent, userPrivilege]);

	const handleOnClick = () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'link',
				actionSubjectId: 'whiteboardsPremiumOnboardingLearnMoreLink',
				attributes: {
					userPrivilege: `${userPrivilege}`,
				},
			},
		}).fire();
	};

	return (
		<FormattedMessage
			{...body}
			values={{
				learnMoreLink: (chunks: React.ReactNode[]) => (
					<a
						href="https://www.atlassian.com/software/confluence/whiteboards"
						target="_blank"
						data-testid={LEARN_MORE_LINK_TEST_ID}
						onClick={handleOnClick}
					>
						{chunks}
					</a>
				),
			}}
		/>
	);
};
